import React, { useEffect, useRef } from 'react';
import Lottie from '@shift/lottie';
import track_dark_icon from '../assets/S2M_DarkTheme.json';
import track_light_icon from '../assets/S2M_LightTheme.json';
import link_icon from '../assets/external-link.svg';
import kjua from 'kjua';
import '../SpotlightPlayer.scss';
const QROptions = {
  render: 'svg',
  crisp: true,
  ecLevel: 'Q',
  minVersion: 1,
  fill: '#37474F',
  back: '#FFFFFF',
  quiet: 1,
  mode: 'plain',
  size: 370
};
const Qr = ({
  url,
  fill = '#37474F',
  back = '#FFFFFF',
  size = 370
}) => {
  const element = useRef(null);
  useEffect(() => {
    if (element != null && element.current != null) {
      const options = {
        ...QROptions,
        text: url,
        fill,
        back,
        size
      };
      const qrcode = kjua(options);
      for (const child of (_element$current$chil = element.current.childNodes) !== null && _element$current$chil !== void 0 ? _element$current$chil : []) {
        var _element$current$chil;
        element.current.removeChild(child);
      }
      if (qrcode) {
        element.current.appendChild(qrcode);
      }
    }
  }, [back, fill, size, url]);
  return /*#__PURE__*/React.createElement("div", {
    ref: element
  });
};
const getUpCodeUrl = (trackingCode, domain, deviceId, organizationId, source = '', origin) => {
  if (!domain || !trackingCode) return null;
  const url = new URL(trackingCode, `https://${domain}`);
  if (organizationId != null) {
    url.searchParams.append('organization_id', organizationId);
  }
  if (deviceId != null) {
    url.searchParams.append('device_id', deviceId);
  }
  if (origin != null) {
    url.searchParams.append('origin', origin);
  }
  url.searchParams.append('source', source);
  return url;
};
const UPCode = ({
  tracking,
  properties,
  playing = true,
  clickable = false,
  rightPanelBackgroundColor = null,
  UPcodeBackground = '#fff',
  size = 370,
  deviceId,
  organizationId,
  positionStyles,
  isQRCard = false,
  origin,
  showShortURL = true
}) => {
  const theme = properties.includes('qr-theme-dark') ? 'dark' : 'light';
  const qrUrl = getUpCodeUrl(tracking.tracking_code, tracking.domain, deviceId, organizationId, 'QR', origin);
  const clickableUrl = getUpCodeUrl(tracking.tracking_code, tracking.domain, deviceId, organizationId, 'CLICK', origin);
  const QRCodeRender = () => tracking.default_qr ? /*#__PURE__*/React.createElement("img", {
    src: tracking.default_qr,
    alt: "QR"
  }) : /*#__PURE__*/React.createElement(Qr, {
    url: qrUrl === null || qrUrl === void 0 ? void 0 : qrUrl.href,
    back: UPcodeBackground,
    size: size
  });
  const specificBackgroundColor = rightPanelBackgroundColor || (theme === 'dark' ? '#37474f' : 'white');
  const borderRadius = isQRCard ? '16px' : 0;
  const trackingURL = `${tracking.domain}/${tracking.tracking_code}`;
  return /*#__PURE__*/React.createElement("div", {
    className: `QR ${theme} ${!tracking.logo ? 'without-logo' : ''}`,
    style: {
      backgroundColor: specificBackgroundColor,
      ...positionStyles,
      borderRadius
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "upcode-logo-container",
    style: {
      backgroundColor: UPcodeBackground
    }
  }, !isQRCard && tracking.logo && /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement("img", {
    src: tracking.logo,
    alt: "LOGO"
  })), /*#__PURE__*/React.createElement("div", {
    className: `qr ${tracking.default_qr ? '' : 'autogenerated'}`
  }, clickable ? /*#__PURE__*/React.createElement("a", {
    className: "QR_link",
    target: "_blank",
    href: clickableUrl === null || clickableUrl === void 0 ? void 0 : clickableUrl.href,
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "qr_click"
  }, /*#__PURE__*/React.createElement("img", {
    src: link_icon,
    alt: "icon"
  })), QRCodeRender()) : QRCodeRender())), /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info-text"
  }, "OPEN CAMERA, FOCUS ON CODE, TAP THE LINK!"), /*#__PURE__*/React.createElement(Lottie, {
    className: "info-img",
    isStopped: !playing,
    options: {
      loop: true,
      autoplay: !!playing,
      animationData: theme === 'dark' ? track_light_icon : track_dark_icon
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "info-visit"
  }, tracking.domain && showShortURL && /*#__PURE__*/React.createElement(React.Fragment, null, "OR VISIT:", clickable ? /*#__PURE__*/React.createElement("a", {
    className: "tracking-url",
    target: "_blank",
    href: clickableUrl === null || clickableUrl === void 0 ? void 0 : clickableUrl.href,
    rel: "noopener noreferrer"
  }, " ", trackingURL) : /*#__PURE__*/React.createElement("span", {
    className: "tracking-url"
  }, " ", trackingURL)))));
};
export default UPCode;